import { useTranslation } from 'react-i18next';
import type { PopupCountByStatus, PopupStatus } from '../../models/Popup';

export type PopupStatusTab = PopupStatus;

interface StatusTabsProps {
  activeTab: PopupStatusTab;
  onTabChange: (tab: PopupStatusTab) => void;
  statusCounts?: PopupCountByStatus;
  isLoadingCounts?: boolean;
}

const TABS: PopupStatusTab[] = ['active', 'archived'];

export function StatusTabs({
  activeTab,
  onTabChange,
  statusCounts = { active: 0, archived: 0 },
  isLoadingCounts = false,
}: StatusTabsProps) {
  const { t } = useTranslation('popups');

  return (
    <div
      className="flex overflow-x-auto rounded-lg bg-card-bg p-1 text-sm scrollbar-hide light:border light:border-card-border"
      role="tablist"
      aria-label={t('tabs.statusFilter')}
    >
      {TABS.map((tab) => {
        const isActive = tab === activeTab;
        const count = statusCounts[tab];

        return (
          <button
            key={tab}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onTabChange(tab)}
            data-testid={`popups-status-tab-${tab}`}
            className={`flex items-center gap-1.5 whitespace-nowrap rounded px-3 py-1 transition-colors hover:bg-hover-press ${
              isActive ? 'bg-hover-press' : ''
            }`}
          >
            <span>{t(`filters.status.${tab}`)}</span>
            <span
              className={`min-w-[20px] rounded-full px-1.5 py-0.5 text-center text-xs ${
                isActive ? 'bg-primary/20 text-primary' : 'bg-muted text-muted-foreground'
              } ${isLoadingCounts ? 'animate-pulse' : ''}`}
            >
              {count}
            </span>
          </button>
        );
      })}
    </div>
  );
}
